(() => {
  const init = (root) => {
    if (!root || root.dataset.conquerorReady === '1') return;
    root.dataset.conquerorReady = '1';

    const pageId = root.dataset.sectionId;
    const film = root.querySelector('.film');
    const stage = root.querySelector('.film-stage');
    const video = root.querySelector('.film-video');
    const fbar = root.querySelector('.film-track');
    const marks = [...root.querySelectorAll('.film-marks span')];
    const chapters = [...root.querySelectorAll('.chapter')];
    const markSection = root.querySelector('.mark');
    const sheetEl = markSection?.querySelector('.sheet');
    const sigPath = root.querySelector('.sig-path');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    try { sigPath?.style.setProperty('--len', sigPath.getTotalLength().toFixed(1)); } catch(e) { sigPath?.style.setProperty('--len','1200'); }

    let duration = 0, targetTime = 0, seeking = false, ready = false;
    const seek = () => {
      if (!video || !ready || seeking || !duration || reduce) return;
      seeking = true;
      try { video.currentTime = targetTime; } catch(e) { seeking = false; }
    };
    if (video) {
      video.addEventListener('loadedmetadata', () => { duration = video.duration || 0; video.pause(); ready = true; video.classList.add('ready'); seek(); });
      video.addEventListener('seeked', () => { seeking = false; if (Math.abs(video.currentTime - targetTime) > .04) seek(); });
      video.addEventListener('error', () => video.classList.remove('ready'));
      const kick = () => video.play().then(() => video.pause()).catch(() => {});
      addEventListener('touchstart', kick, {once:true, passive:true});
      addEventListener('click', kick, {once:true});
    }

    let ticking = false;
    const render = () => {
      ticking = false;
      if (film) {
        const fr = film.getBoundingClientRect();
        const fScroll = film.offsetHeight - innerHeight;
        const p = fScroll > 0 ? Math.min(1, Math.max(0, -fr.top / fScroll)) : 0;
        root.style.setProperty('--progress', p.toFixed(4));
        fbar?.setAttribute('aria-valuenow', Math.round(p * 100));
        if (duration) { targetTime = Math.min(Math.max(0, duration - .05), p * duration); seek(); }
        let active = 0;
        chapters.forEach((c,i) => { const on = p >= Number(c.dataset.from) && p < Number(c.dataset.to); c.classList.toggle('show', on); if (on) active = i; });
        marks.forEach((m,i) => m.classList.toggle('on', i === active));
      }
      if (sheetEl) {
        const sh = sheetEl.getBoundingClientRect();
        const start = innerHeight * .85, end = innerHeight * .06;
        root.style.setProperty('--sig', Math.min(1, Math.max(0,(start - sh.top)/(start - end))).toFixed(4));
      }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(render); } };
    render(); addEventListener('scroll', onScroll, {passive:true}); addEventListener('resize', onScroll);

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { es.forEach(e => { if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:.18, rootMargin:'0px 0px -8% 0px'});
      root.querySelectorAll('.rv').forEach(el => io.observe(el));
    } else root.querySelectorAll('.rv').forEach(el => el.classList.add('in'));

    const panel = root.querySelector('.product-panel');
    if (!panel) return;
    const variantsNode = panel.querySelector('[data-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const qtyEl = panel.querySelector('[data-qty]');
    const subEl = panel.querySelector('[data-subtotal]');
    const priceEl = panel.querySelector('[data-price]');
    const stockEl = panel.querySelector('[data-stock]');
    const atc = panel.querySelector('[data-atc]');
    const message = panel.querySelector('[data-message]');
    const currency = root.dataset.currency || 'GBP';
    let qty = 1;
    let selectedVariant = variants[0] || null;

    const money = cents => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency}).format((cents || 0)/100); }
      catch(e) { return '£' + ((cents || 0)/100).toFixed(2); }
    };
    const findVariant = () => {
      if (!variants.length) return null;
      const selected = [...panel.querySelectorAll('.opts')].map(group => group.querySelector('.opt[aria-pressed="true"]')?.dataset.value || '');
      return variants.find(v => v.options.every((opt,i) => opt === selected[i])) || variants[0];
    };
    const recalc = () => {
      selectedVariant = findVariant();
      if (!selectedVariant) return;
      if (priceEl) priceEl.textContent = money(selectedVariant.price);
      if (qtyEl) qtyEl.textContent = qty;
      if (subEl) subEl.textContent = money(selectedVariant.price * qty);
      if (stockEl) stockEl.innerHTML = '<span class="dot" aria-hidden="true"></span>' + (selectedVariant.available ? ' In stock' : ' Currently unavailable');
      if (atc) atc.disabled = !selectedVariant.available;
      if (history.replaceState && selectedVariant.id) {
        const u = new URL(location.href); u.searchParams.set('variant', selectedVariant.id); history.replaceState({},'',u);
      }
    };

    panel.querySelectorAll('.opts').forEach(group => group.addEventListener('click', e => {
      const b = e.target.closest('.opt'); if (!b) return;
      [...group.querySelectorAll('.opt')].forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      recalc();
    }));
    panel.querySelector('[data-minus]')?.addEventListener('click', () => { qty=Math.max(1,qty-1); recalc(); });
    panel.querySelector('[data-plus]')?.addEventListener('click', () => { qty=Math.min(99,qty+1); recalc(); });
    atc?.addEventListener('click', async () => {
      if (!selectedVariant || !selectedVariant.available) return;
      atc.disabled = true; message.classList.remove('is-error'); message.textContent = 'Adding to basket…';
      try {
        const res = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selectedVariant.id,quantity:qty}]})});
        if (!res.ok) throw new Error((await res.json()).description || 'Unable to add item');
        atc.textContent = 'Added to basket'; message.innerHTML = '<a href="/cart">View basket →</a>';
        setTimeout(() => { atc.textContent='Add to basket'; atc.disabled=false; },1800);
      } catch(err) { atc.disabled=false; message.classList.add('is-error'); message.textContent=err.message || 'Unable to add item. Please try again.'; }
    });
    root.querySelector('[data-scroll-buy]')?.addEventListener('click', () => root.querySelector('[id^="conqueror-buy-"]')?.scrollIntoView({behavior: reduce ? 'auto':'smooth'}));
    recalc();
  };

  const boot = () => document.querySelectorAll('.conqueror-page').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('.conqueror-page')));
})();
